import { Link } from "gatsby"
import styled from "@emotion/styled"
import PropTypes from "prop-types"
import React from "react"
import { OutboundLink } from 'gatsby-plugin-google-gtag'




const NavLink = styled(Link)`
  margin-left: 15px;
  text-decoration: none;
  display: inline-block;
  position: relative;

  ::after {
    content: "";
    position: absolute;
    width: 100%;
    transform: scaleX(0);
    height: 2px;
    bottom: 0;
    left: 0;
    background-color: #8bf9db;
    transform-origin: bottom right;
    transition: transform 0.4s cubic-bezier(0.86, 0, 0.07, 1);
  }

  :hover::after {
    transform: scaleX(1);
    transform-origin: bottom left;
  }
`

const ExternalLink = styled(OutboundLink)`
  margin-left: 15px;
  text-decoration: none;
  display: inline-block;
  position: relative;

  ::after {
    content: "";
    position: absolute;
    width: 100%;
    transform: scaleX(0);
    height: 2px;
    bottom: 0;
    left: 0;
    background-color: #8bf9db;
    transform-origin: bottom right;
    transition: transform 0.4s cubic-bezier(0.86, 0, 0.07, 1);
  }

  :hover::after {
    transform: scaleX(1);
    transform-origin: bottom left;
  }
`

const LinkContainer = styled.p`
  margin-left: -15px;
  margin-top: 10px;
  font-size: 1.2rem;
`

const HomeLink = styled(NavLink)`
  margin-left: 10px;
`

const Navigation = ({ showHomeLink }) => (
  <LinkContainer>
  {showHomeLink ? <HomeLink to="/">Home</HomeLink> : null}
  <NavLink to="/blog">Blog</NavLink>
  {/* <NavLink to="/contact">Contact</NavLink> */}
  <ExternalLink href="https://scholar.google.com/citations?user=emVOlUkAAAAJ" target="_blank">
    Papers
  </ExternalLink>
  <ExternalLink href="https://www.techwolf.ai" target="_blank">
    TechWolf
  </ExternalLink>
</LinkContainer>

)

export default Navigation
